import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/automation-support/')({
  head: () => buildHead('/products/automation-support'),
});
